import React, {useEffect, useRef, useState} from 'react';
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../service/ToolsService";

export const Header = () => {
  const [show, setShow] = useState(false);
  const dropdownRef = useRef<HTMLDivElement | null>(null);


  useEffect(() => {
    // Fonction de gestion du clic en dehors
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setShow(false);  // Fermer le dropdown
      }
    };

    // Ajouter un écouteur d'événement pour le clic
    document.addEventListener('mousedown', handleClickOutside);

    // Nettoyage de l'écouteur d'événement lors du démontage du composant
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="__admin_header__">
        <div className="d-flex flex-nowrap align-items-center ps-3 pe-3">
          <div className="col max-w300px">
            <h2 className="__front_h2__"><NavLink to="/admin" onClick={scrollTo}>C’Team Chartres</NavLink></h2>
          </div>
          <div className="col d-flex justify-content-end __admin_header_action__">
            <NavLink to="/" onClick={scrollTo} className="me-3">retourner sur le site</NavLink>

            <div className="dropdown" ref={dropdownRef}>
              <button className="btn btn-link p-0" type="button" onClick={() => setShow(!show)}>
                <i className="fa-solid fa-circle-user cursor-pointer"></i>
              </button>
              <ul className={`dropdown-menu dropdown ${show ? 'show' : ''}`}>
                <li>
                  <NavLink to="/admin/profil" onClick={() => {setShow(!show); scrollTo();}} className="dropdown-item">Profil</NavLink>
                </li>
                <li>
                  <NavLink to="/admin/logout" onClick={() => {setShow(!show); scrollTo();}} className="dropdown-item">Déconnexion</NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
